import { FC } from 'react';
import { useState, useEffect } from 'react';

import { StyledTextAreaDiv } from './index.styles';
import { TRCTextAreaProps } from './index.types';
import clsx from 'clsx';

export const TRCTextArea: FC<TRCTextAreaProps> = ({
  textareaId,
  textareaName,
  textareaLabel,
  textareaLabelClassName,
  isError,
  errorMessage,
  errorMessageClassName,
  maxLength,
  className,
  mandatory,
  innerClassName,
  placeholder,
  inputValue,
  onChange,
  disabled,
}) => {
  const [isErrorBlur, setIsError] = useState(false);

  useEffect(() => {}, [isError]);

  const onChangeChild = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    // 👇 Get input value from "event"
    onChange(event.target.value);
    if (mandatory === true && event.target.value === '') {
      setIsError(true);
    } else {
      setIsError(false);
    }
  };

  const inputBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (mandatory === true && e.target.value === '') {
      setIsError(true);
    } else {
      setIsError(false);
    }
  };

  return (
    <StyledTextAreaDiv
      data-component-name="a-trc-TRCTextArea"
      className={clsx('m-text-area', className, isError || isErrorBlur ? 'is-error' : 'is-active')}
    >
      <span id={`rfp-${textareaName}`}></span>
      <label htmlFor={textareaId}>
        <span className={textareaLabelClassName}>
          {textareaLabel}
          {mandatory ? '*' : ''}
        </span>
      </label>
      <textarea
        name={textareaName}
        id={textareaId}
        className={innerClassName}
        placeholder={placeholder}
        value={inputValue}
        onBlur={inputBlur}
        onChange={onChangeChild}
        maxLength={maxLength}
        disabled={disabled}
        required={mandatory ? true : false}
      ></textarea>
      {(isErrorBlur || isError) && (
        <span className={clsx(errorMessageClassName, 'error-text t-font-xs')}>{errorMessage}</span>
      )}
    </StyledTextAreaDiv>
  );
};

export default TRCTextArea;
